import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CommonConstants,
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { MembershipCardResponse } from '../../models/api/membership-card.interfaces';

@Injectable({
  providedIn: 'root'
})
export class MembershipCardService {
  errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getMembershipCard = (): Observable<MembershipCardResponse> =>
    new ApiBuilder<unknown, MembershipCardResponse>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_API_MEMBERSHIP_CARD'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();
}
